/******/ (() => {
  // webpackBootstrap
  var __webpack_exports__ = {};
  window.PXUTheme.jsMegaMenu = {
    init: function ($section) {
      // Add settings from schema to current object
      window.PXUTheme.jsMegaMenu = $.extend(
        this,
        window.PXUTheme.getSectionData($section),
      );

      // Selectors
      const parentLink = this.parent_link;
      const sectionId = this.section_id;
      const resetParfumsPanels = function () {
        const $parfumsMenus = $('.mega-menu[data-products-panel="true"]');

        $parfumsMenus.each(function () {
          const $menu = $(this);
          $menu.find(".mega-menu__products").removeClass("is-active");
          $menu
            .find('.mega-menu__products[data-default="true"]')
            .addClass("is-active");
          $menu
            .find(".mega-menu__linklist-link[data-collection-handle]")
            .removeClass("is-hovered");
        });
      };
      const $megaMenu = $section.find(".mega-menu__" + sectionId);
      const $parentElement = $(
        '.header__menu [data-navlink-handle="' +
          parentLink +
          '"], .sticky-header__menu [data-navlink-handle="' +
          parentLink +
          '"]',
      );
      const $parentElementLink = $parentElement.find(".header__link");
      // Remove old mega menus
      $parentElement.find(".mega-menu__section").remove();

      // Mobile Selectors
      const $parentMobileElement = $(
        `[data-mobile-menu-navlink-handle="${parentLink}"]`,
      );

      /* No submenu is present - add mega menu elements and caret */
      if ($parentMobileElement.find(".has-no-submenu").length) {
        // Assign class to display dropdown arrow
        $parentMobileElement
          .find("a.mobile-menu__item")
          .addClass("mobile-menu-link");

        // Insert close icon after menu item
        $parentMobileElement
          .find("a")
          .after('<span class="close-dropdown" aria-expanded="false"></span>');

        // Insert placeholder ul for megamenu
        $parentMobileElement
          .find(".submenu__label")
          .after(
            '<ul class="mobile-submenu__list mobile-menu__submenu has-mega-menu" data-mobile-submenu-first-level-list></ul>',
          );

        // Find data attribute for toggle and assign it true
        let $mobileMenuToggle = $parentMobileElement.find(
          "[data-mobile-menu-has-toggle]",
        );
        $($mobileMenuToggle).attr("data-mobile-menu-has-toggle", true);

        // Insert mega menu
        let $parentList = $parentMobileElement.find(".has-mega-menu");
        $megaMenu.clone().appendTo($parentList);
      } else {
        /* Submenu is present - add mega menu elements and remove current sub-menu */
        let $parentList = $parentMobileElement.find(
          "[data-mobile-submenu-first-level-list]",
        );

        $parentList
          .empty()
          .addClass("has-mega-menu")
          .removeClass("has-dropdown");

        // Insert mega menu
        $megaMenu.clone().appendTo($parentList);
      }

      // On mobile, a parent link with a mega menu should only expand its
      // submenu on tap, not navigate away (the mega menu content is the
      // point of tapping it, not the parent collection page).
      $parentMobileElement.addClass("has-mobile-mega-menu");

      // Desktop
      if (
        $parentElement.hasClass("header__item") ||
        $parentElement.hasClass("vertical-header__first-level")
      ) {
        // Hide default dropdown
        $parentElement
          .find(".navbar-dropdown")
          .addClass("is-invisible is-hidden");

        // Add arrow to parent link to indicate dropdown
        $parentElementLink.removeClass("is-arrowless");

        $megaMenu
          .clone()
          .appendTo(
            '.vertical-header__first-level[data-navlink-handle="' +
              parentLink +
              '"], .header__item[data-navlink-handle="' +
              parentLink +
              '"]',
          );

        // Add/remove classes for proper styling and append mega menu instance
        $parentElement.addClass("has-mega-menu");

        const $clonedMegaMenu = $parentElement.find(
          '.mega-menu[data-parent-link="' + parentLink + '"]',
        );
        if ($clonedMegaMenu.attr("data-products-panel") === "true") {
          this.bindParfumsCollectionHover($clonedMegaMenu);
        }
      }

      // Determine if header is set to hover to open or click to open
      if ($(".dropdown-click--false").length > 0) {
        $(".navbar-item, .header__brand, .header__search").on(
          "mouseenter",
          function () {
            //Close any mega menus on hover
            resetParfumsPanels();
            $(".mega-menu__section").removeClass("is-active");

            if ($(this).hasClass("has-mega-menu")) {
              //Toggle corresponding mega menu
              $(this).find(".mega-menu__section").addClass("is-active");
            }
          },
        );

        $(".mega-menu__section, .navbar").on("mouseleave", function () {
          //Hide mega menu upon leaving mega menu, logo or navbar
          resetParfumsPanels();
          $(".mega-menu__section").removeClass("is-active");
        });
      } else {
        $(".navbar-item, .header__brand, .header__search").on(
          "click touchstart",
          function () {
            //Close any mega menus on click
            resetParfumsPanels();
            $(".mega-menu__section").removeClass("is-active");

            if ($(this).hasClass("has-mega-menu")) {
              //Toggle corresponding mega menu
              $(this).find(".mega-menu__section").addClass("is-active");
            }
          },
        );
      }
    },
    showThemeEditorState: function (id, $section) {
      $(".mega-menu__" + id + " .mega-menu").addClass("mega-menu--force-show");
      $(".mega-menu__" + id + " .mega-menu")
        .prev(".header__link")
        .addClass("is-active");
    },
    hideThemeEditorState: function (id, $section) {
      $(".mega-menu__" + id + " .mega-menu").removeClass(
        "mega-menu--force-show",
      );
      $(".mega-menu__" + id + " .mega-menu")
        .prev(".header__link")
        .removeClass("is-active");
    },
    displayMenu: function (id) {
      $(".mega-menu").removeClass("mega-menu--show");
      $(".mega-menu__" + id + " .mega-menu").addClass("mega-menu--show");
    },
    hideMenu: function (id) {
      $(".mega-menu__" + id + " .mega-menu").removeClass("mega-menu--show");
    },
    bindParfumsCollectionHover: function ($megaMenuScope) {
      if (!$megaMenuScope || !$megaMenuScope.length) {
        return;
      }

      const productsSelector = ".mega-menu__products";
      const collectionProductsSelector =
        ".mega-menu__products[data-collection-products]";
      const hoverableLinkSelector =
        '.mega-menu__linklist-link[data-collection-handle][data-hoverable="true"]';
      const nonHoverableLinkSelector =
        '.mega-menu__linklist-link[data-collection-handle][data-hoverable="false"]';
      const allCollectionLinkSelector =
        ".mega-menu__linklist-link[data-collection-handle]";

      const showDefaultProducts = function ($scope) {
        $scope.find(productsSelector).removeClass("is-active");
        $scope
          .find('.mega-menu__products[data-default="true"]')
          .addClass("is-active");
        $scope.find(allCollectionLinkSelector).removeClass("is-hovered");
      };

      const showCollectionProducts = function ($scope, collectionHandle) {
        const $target = $scope.find(
          collectionProductsSelector +
            '[data-collection-products="' +
            collectionHandle +
            '"]',
        );

        if (!$target.length) {
          showDefaultProducts($scope);
          return;
        }

        $scope.find(productsSelector).removeClass("is-active");
        $target.addClass("is-active");
      };

      $megaMenuScope.off("mouseenter.parfumsProducts", hoverableLinkSelector);
      $megaMenuScope.off(
        "mouseenter.parfumsProducts",
        nonHoverableLinkSelector,
      );

      $megaMenuScope.on(
        "mouseenter.parfumsProducts",
        hoverableLinkSelector,
        function () {
          const collectionHandle = $(this).data("collection-handle");

          $megaMenuScope
            .find(allCollectionLinkSelector)
            .removeClass("is-hovered");
          $(this).addClass("is-hovered");
          showCollectionProducts($megaMenuScope, collectionHandle);
        },
      );

      $megaMenuScope.on(
        "mouseenter.parfumsProducts",
        nonHoverableLinkSelector,
        function () {
          showDefaultProducts($megaMenuScope);
        },
      );

      showDefaultProducts($megaMenuScope);
    },
    unload: function ($section) {
      let parentLink = $section.find(".mega-menu").data("parent-link");
      let navLink = $('[data-navlink-handle="' + parentLink + '"]');
      navLink.off();
      navLink.find(".mega-menu__section").remove();
      $(
        ".mega-menu__section, .navbar, .navbar-item, .header__brand, .header__search",
      ).off();
    },
  };

  /******/
})();
